import { faCircleInfo } from '@fortawesome/pro-light-svg-icons'
import { useCallback } from 'react'
import { ITLayoutTableModalOpenSetTy } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { RowData } from '../../../../../../../baseComponents/TwinTable/types'
import { ITIconToolTip } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Displays'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { TwinDictionary } from '../../../../../../../utils/globals/dictionary'
import { DisplayStatusToolTip } from '../../../../../../../baseComponents/Displays/DisplayStatus'
import { getAllWorkSheetGroupStatuses } from '../../../../../../../utils/reducers/getters'

export interface OrderProductWorkSheetStatusProps extends OrderProductWorkSheetStatusLogicProps {
    readOnlyFnc?: (allRowData: RowData) => boolean
    extraToolTipStr?: string
}

const OrderProductWorkSheetStatus: React.FC<OrderProductWorkSheetStatusProps> = ({ allRowData, extraToolTipStr, ...rest }) => {
    const { t } = useTwinTranslation()
    const { myOpenModal } = useOrderProductWorkSheetStatusLogic({ allRowData, ...rest })
    if (!allRowData?.haveWorkSheetProductStatus) {
        return null
    }
    if (allRowData?.['UniquePKSellProduct.WorkSheetProductId']) {
        const myWorkSheetProductStatusId = allRowData?.WorkSheetProductStatusId
        const myWorkSheetStatusGroupId = allRowData?.WorkSheetGroupStatusId
        const workSheetProductStatuses: any = getAllWorkSheetGroupStatuses()
        const dictWorkSheetGroupStatus = workSheetProductStatuses?.dictWorkSheetGroupStatus?.[myWorkSheetStatusGroupId]?.WorkSheetProductStatusesDict
        const myStatus = dictWorkSheetGroupStatus?.[myWorkSheetProductStatusId]
        return <DisplayStatusToolTip text={myStatus?.name || t('withoutStatus', 'Sin estado')} colorText={myStatus?.color} className='w-full py-1' idTooltip={'workSheetProductStatus-' + allRowData?.id + (extraToolTipStr || '')} />
    }
    return (
        <ITIconToolTip message={t('statusInformation', 'Información del estado')} id={'showStatusInformation' + allRowData.id + (extraToolTipStr || '')} icon={faCircleInfo} onClick={myOpenModal} className='mx-auto'></ITIconToolTip>
    )
}

interface OrderProductWorkSheetStatusLogicProps {
    setOpenModal: ITLayoutTableModalOpenSetTy
    allRowData: RowData
    Order: TwinDictionary
}

const useOrderProductWorkSheetStatusLogic = ({ allRowData, setOpenModal, Order }: OrderProductWorkSheetStatusLogicProps) => {
    const myOpenModal = useCallback(() => {
        allRowData['WorkSheetId'] = Order.WorkSheetId
        allRowData['relatedWorkSheets'] = Order.relatedWorkSheets
        setOpenModal({ allRowData, type: 'workSheetStatus' })
    }, [setOpenModal, allRowData, Order.WorkSheetId, Order.relatedWorkSheets])
    return { myOpenModal }
}

export default OrderProductWorkSheetStatus 